import React, { useState, useRef } from 'react';
import { useTranslation } from '../hooks/useTranslation';
import { Customer } from '../services/customersService';
import { ModernCustomerList } from './ModernCustomerList';
import { ModernCustomerForm } from './ModernCustomerForm';

export const ModernCustomerManagement: React.FC = () => {
  const { translate } = useTranslation();
  const [formOpen, setFormOpen] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState<Customer | null>(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const listRef = useRef<{ refresh: () => void }>(null);

  const handleCreateClick = () => {
    setEditingCustomer(null);
    setFormOpen(true);
  };

  const handleEditClick = (customer: Customer) => {
    setEditingCustomer(customer);
    setFormOpen(true);
  };

  const handleFormClose = () => {
    setFormOpen(false);
    setEditingCustomer(null);
  };

  const handleFormSave = async (customer: Customer) => {
    console.log('✅ handleFormSave called, closing dialog first');
    setFormOpen(false);
    setEditingCustomer(null);

    // Trigger refresh of the customer list after a delay to ensure API call completes
    setTimeout(() => {
      setRefreshKey((prev) => {
        console.log(`✅ refreshKey changed from ${prev} to ${prev + 1}`);
        return prev + 1;
      });
    }, 1000);
  };

  return (
    <div className="container mx-auto p-6" data-testid="customer-management">
      <ModernCustomerList
        refreshTrigger={refreshKey}
        onCreateClick={handleCreateClick}
        onEditClick={handleEditClick}
      />

      <ModernCustomerForm
        open={formOpen}
        onClose={handleFormClose}
        onSave={handleFormSave}
        customer={editingCustomer}
      />
    </div>
  );
};

